<main [ngClass]="{'admin-login': isAdmin}" class="content-img">
  <mat-tab-group class="cardGroup">
    <mat-tab label="LOG IN" class="login">
      <form [formGroup]="authForm">
        <p class="bienvenida">Welcome! <br>
          <span class="mensajeBienvenida">Log in to access our bamba agent booking site:</span></p>

        <div class="inputs">
          <mat-form-field class="userName" appearance="outline">
            <mat-label>User / Email</mat-label>
            <input matInput formControlName="Email" type="text">
          </mat-form-field>
        </div>

        <div class="inputs">
          <mat-form-field class="password" appearance="outline" floatLabel="auto" hideRequiredMarked>
            <mat-label>Password</mat-label>
            <input matInput type="string" formControlName="Password" placeholder="Enter your password"
                   [type]="!hide ? 'password' : 'text'">
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide">
              <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>
        </div>


        <p style="display:none" class="contraseña"><a href="#">Forgot your password?</a></p>

        <mat-error *ngIf="loginFailed">Wrong email and/or password. Please try again</mat-error>

        <button [disabled]="authForm.invalid" mat-button class="btnLogin" (click)="authenticate()">LOG IN</button>


        <p style="font-weight: 300;font-size:10px;margin-top: 10px;" class="sub-text">If you want to log-in to the old
          Darwin <a class="link" href="https://www.bambabus.com/agentLogin.php"> Click here </a>.</p>

      </form>
    </mat-tab>

    <mat-tab label="NEW AGENCY" class="newagency">
      <p class="bienvenida bienvenidaNew">Agency not registered?<br><span class="mensajeBienvenida">Set up your
          new
          agency now. </span></p>

      <a href="https://bamba.itravelsoftware.com/itravel/admin/tvrtke/RegistracijaPartnera.aspx?sifraJezik=2" mat-button
         target="_blank" class="btnLogin">REGISTER NEW AGENCY</a>
    </mat-tab>
  </mat-tab-group>
</main>
